import React from "react";

import { Link } from 'react-router-dom';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';

import {connect} from 'react-redux';
const NotFound = ({}) => {
  return (
    <div>
            <Header/> 
			<div className="container">
				<div className="form-sec">
    					<h1>Page Not Found</h1>
					<h1>404</h1>
                    <h2>Oops! Page not found.</h2>
                    <p>We can't seem to find the page you're looking for.</p>
					<Link to="/" className="btn btn-primary primary-btn">Go Back Home</Link>
				</div>
				<div className="inner-bg">
					<div className="content">
						<div className="custom-font">ELEVATING DJ CULTURE ONE BEAT AT A TIME.</div>
						<h2>The world’s most influential DJ community & lifestyle brand.</h2>
                        
					</div>
				</div>	
			</div>
			
			<Footer />
		</div>
  );
}

function mapStateToProps(state) {
    return {
        
    };
}

function mapDispatchToProps(dispatch) {
    return {
        
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);